import { Fragment, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  // const { token } = useSelector(state => state.Auth)

  useEffect(() => {}, []);

  // if (!token) {
  //   return (
  //     <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
  //   );
  // }

  return <Fragment>{props.children}</Fragment>;
};

export default Authmiddleware;
